import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { TrailSystemContract } from '@polaris-customerweb/sharedcomponents.core';
import { RideArea } from '@polaris-customerweb/sharedcomponents.map';
import { RoutingHelpersService } from '@polaris-customerweb/sharedcomponents.shared';
import { isEmpty, isSet } from 'lodash-es';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RideAreaResource {
    private trailSystemsUrl: string;

    constructor(
        private configService: ConfigService,
        private http: HttpClient,
        private routingHelpersService: RoutingHelpersService
    ) {
        this.trailSystemsUrl = routingHelpersService.combineUrl(
            configService.apiUrl.rideCommand,
            'v1/trailsystems'
        );
    }

    getRideAreaById(rideAreaId: string): Observable<RideArea> {
        const params = new HttpParams().set('skipAuthorization', 'true');
        const url = this.routingHelpersService.combineUrl(
            this.trailSystemsUrl,
            rideAreaId
        );

        return this.http
            .get<TrailSystemContract>(url, { params })
            .pipe(
                map(
                    (rideAreaContract) =>
                        new RideArea(
                            rideAreaContract,
                            this.configService.appSku
                        )
                )
            );
    }

    getRideAreasByLocation(
        lat: number,
        lng: number,
        dist: number,
        vehicleTypes?: string,
        rideAreaTypes?: string,
        name?: string,
        lastModified?: string,
        max?: number
    ): Observable<RideArea[]> {
        let params = new HttpParams()
            .set('trailSystemFilter.lat', String(lat))
            .set('trailSystemFilter.lng', String(lng))
            .set('trailSystemFilter.dst', String(dist))
            .set('skipAuthorization', 'true');

        if (!isEmpty(vehicleTypes)) {
            params = params.set(
                'trailSystemFilter.vehicleClassTypes',
                vehicleTypes || ''
            );
        }
        if (!isEmpty(name)) {
            params = params.set('trailSystemFilter.name', name || '');
        }
        if (isSet(lastModified)) {
            params = params.set(
                'trailSystemFilter.lastModifiedDate',
                lastModified
            );
        }
        if (!isEmpty(rideAreaTypes)) {
            params = params.set(
                'trailSystemFilter.trailSystemTypes',
                rideAreaTypes || ''
            );
        }
        if (!isEmpty(max)) {
            params = params.set('trailSystemFilter.max', String(max));
        }

        return this.http
            .get<TrailSystemContract[]>(this.trailSystemsUrl, { params })
            .pipe(
                map((rideAreaContracts) =>
                    rideAreaContracts.map(
                        (dto) => new RideArea(dto, this.configService.appSku)
                    )
                )
            );
    }

    getAllRideAreas(): Observable<RideArea[]> {
        const params = new HttpParams()
            .set('trailSystemFilter.max', '5000')
            .set('skipAuthorization', 'true');

        return this.http
            .get<TrailSystemContract[]>(this.trailSystemsUrl, { params })
            .pipe(
                map((rideAreaContracts) =>
                    rideAreaContracts.map(
                        (dto) => new RideArea(dto, this.configService.appSku)
                    )
                )
            );
    }
}
